import { ProfessionalFormationTypeEnum } from '@medprev-web-app/api-graphql-client';

import { Rating } from '@/types';
import { Honorific } from '@/types/enums/honorific.enum';
import { FacilityType } from '@/types/enums/facility-type.enum';

export { FacilityType };

export type ProfessionalLicense = {
  certificationBodyId: string;
  certificationBodyInitials: string;
  certificationBodyName: string;
  licenseState: string;
  licenseRecord: string;
};

export type ProfessionalSpecialty = {
  id: string;
  name: string;
  description: string;
  specialistQualificationRecord?: string;
};

export type ProfessionalFormation = {
  type: ProfessionalFormationTypeEnum;
  description: string;
  location: string;
  completionYear: string | undefined;
};

export type OnlineProfessional = {
  id: string;
  name: string;
  licenses: ProfessionalLicense[];
  specialties: ProfessionalSpecialty[];
  honorific: Honorific;
  description?: string;
  professionalFormations?: ProfessionalFormation[];
  treatments?: string[];
  languageAndAccessibility?: string[];
  slug: string;
  minAge?: number;
  maxAge?: number;
  followUp?: number;
  avatar?: string;
  avatarSmall?: string;
  avatarLarge?: string;
  rating: Rating;
};

export type ScheduleProcedure = {
  id: string;
  name: string;
  code: string;
  type: string;
  tussCode: string;
  description: string;
  availableForTelehealth: boolean;
  price: number;
};

export type SchedulesSearchPartner = {
  id: string;
  distance: string;
  avatar: string;
  description: string;
  socialName: string;
  facility: OnlinePartnerFacility;
  score: number;
};

export type OnlinePartnerFacility = {
  id: string;
  zipcode: string;
  addressLine1: string;
  addressLine2?: string;
  number: string;
  neighborhood: string;
  city: string;
  IBGECode: string;
  state: string;
  contacts: PartnerFacilityContact;
  type: FacilityType;
  name: string;
  rating?: Rating;
  slug?: string;
};

export type PartnerFacilityContact = {
  email: string;
  phones: string[];
  whatsapp: string;
};

export enum ServiceChannel {
  IN_PERSON = 'IN_PERSON',
  TELEHEALTH = 'TELEHEALTH',
}

export const ServiceChannelMap: Record<ServiceChannel, string> = {
  [ServiceChannel.IN_PERSON]: 'Presencial',
  [ServiceChannel.TELEHEALTH]: 'Teleconsulta',
};

export interface SearchProfessionalSchedulesParams {
  professionalId: string;
  limit?: number;
  page?: number;
  latitude?: number;
  longitude?: number;
  serviceChannel: ServiceChannel;
}

export const ProfessionalFormationTypeTranslationMap = {
  [ProfessionalFormationTypeEnum.Graduation]: 'Graduação',
  [ProfessionalFormationTypeEnum.Postgraduate]: 'Pós-graduação',
  [ProfessionalFormationTypeEnum.Residence]: 'Residência',
  [ProfessionalFormationTypeEnum.MastersDegree]: 'Mestrado',
  [ProfessionalFormationTypeEnum.DoctorateDegree]: 'Doutorado',
  [ProfessionalFormationTypeEnum.PostDoctorate]: 'Pós Doutorado',
  [ProfessionalFormationTypeEnum.Other]: 'Outro',
  [ProfessionalFormationTypeEnum.None]: '',
};
